module.exports = "https://static.zego.com/_next/static/images/social-uber-e6b8d8f4016ba0ff0bfd829b3e4ddf0b.jpg";